import {useAppSelector} from "../../../redux/store";
import {Navigate, useOutletContext} from "react-router-dom";
import {MessageLoader} from "./message.loader";
import {MessageSections} from "../../../pages/components/message/message";
import {Content, MainContentContainer} from "../../styled";
import {Sidebar} from "../../../pages/sidebar";
import UserPage from "../../../pages/user";
import {Footer} from "../../../pages/footer/footer";
import {Settings} from "../../../pages/user/settings/settings";
import {NotificationsList} from "../../../pages/user/notifications/list/notifications-list";
import {NotificationView} from "../../../pages/user/notifications/view/notification-view";
import {Addresses} from "../../../pages/user/addresses/addresses";
import React from "react";
import {OutletContext} from "../../router";
import Notifications from "../../../pages/user/notifications";
import Balance from "../../../pages/user/balance";
import MonthlyLimits from "../../../pages/user/monthly-limits";
import {globalHeaderRef} from "../../../pages/shared/refs";

export const UserRoutes = {
    path: 'user',
    Component: () => {
        const {isOpen} = useAppSelector(state => state.sidebarReducer);
        const {matchesTablet, matchesPc} = useAppSelector(state => state.deviceReducer);

        const outletContext = useOutletContext<OutletContext>();

        return (
            <MessageLoader key={MessageSections.ORDERS} sectionName={MessageSections.USER}>
                <MainContentContainer>
                    <Sidebar headerRef={globalHeaderRef}/>
                    <Content
                        style={{
                            paddingLeft: isOpen
                            && (matchesTablet || matchesPc) ? '15rem' : 'unset'
                        }}>
                        <UserPage context={outletContext}/>

                        <Footer/>
                    </Content>
                </MainContentContainer>
            </MessageLoader>
        )
    },
    children: [
        {
            path: 'settings',
            index: true,
            Component: () => {
                const outletContext = useOutletContext<OutletContext>();
                return <Settings hasValidatedRecipient={outletContext.hasValidatedRecipient}/>;
            }
        },
        {
            path: 'notifications',
            element: <Notifications/>,
            children: [
                {
                    path: '',
                    element: <NotificationsList/>,
                    index: true
                },
                {
                    path: ':notificationId',
                    element: <NotificationView/>,
                }
            ]
        },
        {
            path: 'all',
            Component: () => {
                return <Navigate to={'/'}/>;
            }
        },
        {
            path: 'balance',
            element: <Balance/>
        },
        {
            path: 'my-addresses',
            element: <Addresses size={'m'}/>
        },
        {
            path: 'monthly-limits',
            element: <MonthlyLimits/>
        },
        {
            path: 'warehouse-management',
            element: <></>
        },
        {
            path: 'courier-management',
            element: <></>
        },
    ]
}
